module.exports = __webpack_public_path__ + "templates.membership_reminder-a981dc48.html";